export default function NotFound() {
  return (
    <section className="section">
      <h2>Page Not Found</h2>
      <p className="muted">Sorry, the page you are looking for does not exist.</p>
      <a className="btn" href="/">Return Home</a>
    </section>
  );
}
